import PromotionCodes from "features/PromotionCodes/PromotionCodesList/PromotionCodes";

const PromotionCodesPage: React.FC = () => {
  return <PromotionCodes />;
};

export default PromotionCodesPage;
